import { createSlice } from '@reduxjs/toolkit'
import { PaginationInfoInterface } from '../../components/shared/list/list';

const initialState = {
  loading: false,
  reservationsList: [],
  error: null,
  paginationInfo: null,
  updateDeleteSuccess: false,
  tbLink: null,
  errorTBLink: null,
  rooms: [],
  smartObjects: null
}

const slice = createSlice({
  name: 'reservationsList',
  initialState: initialState,
  reducers: {
    getReservationListAction: (state, action) => {
      state.loading = true
      state.error = null
      state.updateDeleteSuccess = false
    },
    getReservationListSuccessAction:(state, action)=> {
      let paginationInfo : PaginationInfoInterface | null = {
        count: action.payload.reservations.count,
        pageSize: action.payload.reservations.page_size,
        pageCount: action.payload.reservations.page_count,
        next: action.payload.reservations.next,
        previous: action.payload.reservations.previous,
      }

      state.loading = false
      state.error = null
      state.reservationsList = action.payload.reservations.results
      // @ts-ignore
      state.paginationInfo = paginationInfo
      state.rooms = action.payload.rooms
      state.smartObjects = action.payload.smartObjects
    },
    deleteReservationAction:(state, action)=> {
      state.loading = true
      state.error = null
    },
    getReservationUpdateDeleteAction:(state)=> {
      state.loading = false
      state.error = null
      state.updateDeleteSuccess = true
    },
    getReservationListErrorAction: (state, action) => {
      state.loading = false
      state.reservationsList = []
      state.paginationInfo = null
      state.error = action.payload
    },
    getTBLinkAction: (state, action) => {
      state.loading = true
      state.error = null
    },
    tbLinkSuccessAction: (state, action) => {
      state.loading = false
      state.error = null
      state.tbLink = action.payload.link
    },
    tbLinkErrorAction: (state, action) => {
      state.loading = false
      state.errorTBLink = action.payload
      state.tbLink = null
    },
    reservationListPartialResetAction: (state) => {
      state.loading = false
      state.error = null
      state.tbLink = null
    },
    getReservationListResetState: () => initialState,
  },
});

export const {
  getReservationListAction,
  getReservationListSuccessAction,
  getReservationUpdateDeleteAction,
  deleteReservationAction,
  getReservationListErrorAction,
  getReservationListResetState,
  getTBLinkAction,
  tbLinkSuccessAction,
  tbLinkErrorAction,
  reservationListPartialResetAction
} = slice.actions

export default slice.reducer
